export default __webpack_public_path__ + "static/media/JAYALAXMI.08210d5f.JPG";